import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/app/compania/laborator-analize/Highlights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/nextjs/src/components/ScrollWithCarets.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
